module.exports = __webpack_public_path__ + "img/integrations-shopify.d2c2b878.png";